import { render, staticRenderFns } from "./ShopMenu.vue?vue&type=template&id=d383a6d6&"
import script from "./ShopMenu.vue?vue&type=script&lang=js&"
export * from "./ShopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports